import { FitLevel } from 'interfaces';
import Widget from '../Widget/Widget';
import { computed } from 'vue';
import { StudyStoreState } from '@/enums/study-store-state';
import { ScoreDeterminantType } from '@studyportals/bestfit-api-fe-client';

enum ChipStates {
	GREY = 'Grey',
	RED = 'Red',
	YELLOW = 'Yellow',
	GREEN = 'Green',
}

export default class SubDeterminantBadge extends Widget {
	public chipstates = ChipStates;

	public chipLabel = computed((): string => {
		switch (this.determinantType) {
		case ScoreDeterminantType.ACADEMIC_FIT:
			return 'Academic fit';
		case ScoreDeterminantType.BUDGET_FIT:
			return 'Budget fit';
		default:
			return 'Unknown';
		}
	});

	public bestFitScore = computed((): number | null => {
		if (!this.determinantType) {
			return null;
		}

		return (
			this.currentStudyStore.value?.getters.scoreByDeterminant(
				this.determinantType,
			) ?? null
		);
	});

	private currentChipState = computed((): ChipStates => {
		if (this.storeState.value !== StudyStoreState.CALCULATED) {
			return ChipStates.GREY;
		}

		switch (this.displayScore.value as FitLevel) {
		case FitLevel.BETTER_OPTIONS_AVAILABLE:
			return ChipStates.RED;
		case FitLevel.POTENTIAL_MATCH:
			return ChipStates.YELLOW;
		case FitLevel.GOOD_MATCH:
			return ChipStates.GREEN;
		default:
			return ChipStates.GREY;
		}
	});

	public chipIcon = computed((): string => {
		switch (this.currentChipState.value) {
		case ChipStates.RED:
			return 'lnr-thumbs-up Rotated';
		case ChipStates.YELLOW:
			return 'lnr-info';
		case ChipStates.GREEN:
			return 'lnr-thumbs-up';
		default:
			return 'lnr-question-circle';
		}
	});
}
